import '.iv{display:inline-block;}.ssr-plugin'
import '.iw{margin-top:1.5rem;}.ssr-plugin'
import '.b0{font-size:0.875rem;}.ssr-plugin'
import '.ix{color:var(--palette-blue-500);}.ssr-plugin'
import '.hc{text-decoration:underline;}.ssr-plugin'
import { useEffect, useState } from 'react'
import { styled } from 'inlines'

export type DiscoveryCrawlerPaginationFooterProps = {
  nextPageHref: string | null
}

export const DiscoveryCrawlerPaginationFooter = ({
  nextPageHref,
}: DiscoveryCrawlerPaginationFooterProps) => {
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  if (!nextPageHref || mounted) {
    return null
  }

  return (
    <a className="iv iw b0 ix hc"
      rel="next"
      href={nextPageHref}
    >
      next page
    </a>
  )
}
